$(document).ready(function () {

	$("#servicio-diseno-desarrollo").click(function () {
		$(".check").prop('checked', $(this).prop('checked'));
	});

	$("#servicio-marketing").click(function () {
		$(".check1").prop('checked', $(this).prop('checked'));
	});

	$("#servicio-investigacion").click(function () {
		$(".check2").prop('checked', $(this).prop('checked'));
	});

	//marcado de GA
	//variables

	$("[data-track]").each(function () {
		$(this).click(function () {
			var hitType = $(this).attr("data-hitType");
			var eventCategory = $(this).attr("data-eventCategory");
			var eventAction = $(this).attr("data-eventAction");
			var eventLabel = $(this).attr("data-eventLabel");
			var contentID = $(this).attr("data-contentID");
			var socialTarget = $(this).attr("href");
			if (hitType == 'social') {

				gtag('event', 'share', {
					'method': eventLabel,
					'content_id': contentID,
					'event_action': eventAction,
					'event_category': eventCategory
				});
				console.log('Enviando ' + hitType + ' method: ' + eventLabel + ' content_id: ' + contentID + ' event_action: ' + eventAction + ' event_category: ' + eventCategory + ' a GA');

			} else {

				gtag('event', eventAction, {
					'event_category': eventCategory,
					'event_label': eventLabel
				});
				console.log('Enviando ' + hitType + ' event_category: ' + eventCategory + ' event_label: ' + eventLabel + ' a GA');

			}
		})
	});
});